import gql from 'graphql-tag';

export const DELETE_PAYMENT_METHOD = gql`
  mutation DeletePaymentMethod($id: Int!) {
    deletePaymentMethod(id: $id) {
      id
    }
  }
`;

export const deletePaymentMethodMock = {
  deletePaymentMethod: {
    id: 1,
  },
};
